import {
  EditRoutineValues,
  useRoutineService,
} from '~/common/services/RoutineService';
import {
  Department,
  Employee,
} from '~/common/entities/Department/DepartmentTypes';
import { DefaultAlertDialog } from './defaultUIComponents/defaultAlertDialog';
import { useDepartmentService } from '~/common/services/DepartmentService';
import { Routine } from '~/common/entities/Routines/RoutineTypes';
import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { formatName } from '~/common/utils/employeeUtils';
import useTranslate from '~/common/utils/translate';
import { Text } from './defaultUIComponents/Text';
import { DeleteIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';
import _ from 'lodash';

type EmployeesInTileInput = {
  employees: Employee[];
  department?: Department;
  routine?: Routine;
  tooltipLabel: string;
  dialogHeaderText: string;
  dialogBodyText: string;
  onRemoveEmployee?: (employee: Employee) => void;
};

const EmployeesInTile: React.FC<EmployeesInTileInput> = ({
  employees,
  department,
  routine,
  tooltipLabel,
  dialogHeaderText,
  dialogBodyText,
  onRemoveEmployee,
}: EmployeesInTileInput) => {
  const [openDeleteWarning, setOpenDeleteWarning] = useState(false);
  const [idOfPressedButton, setIdOfPressedButton] = useState('');

  const toggleShowDeleteWarning = () => {
    setOpenDeleteWarning(!openDeleteWarning);
  };

  const toggleShowDeleteWarningAndSetId = (
    event: React.MouseEvent<any, MouseEvent>,
  ) => {
    toggleShowDeleteWarning();
    setIdOfPressedButton(event.currentTarget.id);
  };

  const departmentService = useDepartmentService();
  const routineService = useRoutineService();
  const translate = useTranslate();

  const handleDelete = () => {
    const employee = employees.find((e) => e.id == idOfPressedButton);

    const onSuccess = () => {
      if (employees) {
        toggleShowDeleteWarning();
        if (onRemoveEmployee) {
          onRemoveEmployee(employee!);
        }
      }
    };

    if (department) {
      departmentService.removeEmployeeFromDepartment(
        employee!,
        department,
        onSuccess,
      );
    } else if (routine) {
      const newRoutine: EditRoutineValues = {
        name: routine.name,
        durationHours: 0,
        durationMinutes: 0,
        durationSeconds: 0,
        overallDuration: routine.duration,
        description: routine.description,
        employees: routine
          .employees!.filter((e) => e.id != employee!.id)
          .map((e) => e.id),
      };
      console.log(newRoutine);
      routineService.editRoutine(newRoutine, routine, onSuccess);
    }
  };

  return (
    <Flex direction="column">
      {_.orderBy(employees, [(e) => formatName(e)], 'asc')?.map((employee) => (
        <Flex key={employee?.id} align="center" justify="start">
          <Tooltip
            label={translate(tooltipLabel)}
            aria-label={translate(tooltipLabel)}
            placement="top"
          >
            <IconButton
              icon={<DeleteIcon />}
              onClick={toggleShowDeleteWarningAndSetId}
              aria-label={translate(tooltipLabel)!}
              id={employee?.id}
              isRound
              bgColor="transparent"
              color="red.600"
              p={0}
              ml={-2}
              _hover={{
                bgColor: 'transparent',
                color: 'red.600',
                borderWidth: 1,
                borderColor: 'red.600',
              }}
            />
          </Tooltip>

          <Text>{formatName(employee)}</Text>
        </Flex>
      ))}
      <DefaultAlertDialog
        dialogHeaderText={dialogHeaderText}
        dialogBodyText={dialogBodyText}
        isOpen={openDeleteWarning}
        onConfirmedAction={handleDelete}
        onCancel={toggleShowDeleteWarning}
      />
    </Flex>
  );
};

export default EmployeesInTile;
